import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=e3dd3a9e&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=e3dd3a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dd3a9e",
  null
  
)

export default component.exports